// Maps a task's route path to its stepper label. Task paths are the same strings the
// server-side conditions API exchanges as TaskKeys, so a battery defined here can later
// come from that API instead of from STUDIES below without reshaping anything.
export const TASK_CATALOG = [
    { key: '/clock-drawing', label: 'Clock Drawing' },
    { key: '/CASI', label: 'CASI' },
    { key: '/casi-pentagons', label: 'CASI<br>Pentagons' },
    { key: '/verbal-fluency/supermarket/interview', label: 'Verbal Fluency<br>Supermarket' },
    { key: '/verbal-fluency/letter-f/interview', label: 'Verbal Fluency<br>Letter F' },
    { key: '/trail-making/a', label: 'Trail Making A' },
    { key: '/trail-making/b', label: 'Trail Making B' },
    { key: '/hearing-tests', label: 'Hearing Tests' }
];

const INTRODUCTION_STEP = { label: 'Introduction', path: '/introduction' };
const END_STEP = { label: 'End', path: '/end' };

export function buildSteps(taskKeys) {
    const labelByKey = new Map(TASK_CATALOG.map(task => [task.key, task.label]));

    const taskSteps = (taskKeys || [])
        .filter(key => labelByKey.has(key))
        .map(key => ({ label: labelByKey.get(key), path: key }));

    return [INTRODUCTION_STEP, ...taskSteps, END_STEP];
}

// taskKeys === null means the study runs StepperProgress's full defaultSteps battery.
export const STUDIES = [
    {
        key: 'ACTPT',
        label: 'ACTPT',
        lGroupDisplayName: 'ACTPT',
        studyAcronym: 'ACTPT',
        idPattern: /^ACTPT\d+$/,
        visitTypeName: 'Biennial 2025',
        participantPrefix: 'ACTPT',
        // Participants are preallocated server side and carry no workflow tasks, so the
        // dashboard must not create new ones and must not filter to "my visits" only.
        autoCreateLGroup: false,
        allowNewParticipant: false,
        defaultMyVisitsOnly: false,
        taskKeys: ['/trail-making/a', '/trail-making/b', '/clock-drawing', '/casi-pentagons']
    },
    {
        key: 'ACT',
        label: 'ACTB',
        lGroupDisplayName: 'ACT',
        studyAcronym: 'ACTB',
        idPattern: /^ACTB\d+$/,
        visitTypeName: 'Biennial 2025',
        participantPrefix: 'ACTB',
        autoCreateLGroup: true,
        allowNewParticipant: true,
        defaultMyVisitsOnly: true,
        taskKeys: null
    }
];

export const DEFAULT_STUDY_KEY = 'ACTPT';
export const ACTIVE_STUDY_STORAGE_KEY = 'activeStudyKey';

export function getStudy(key) {
    return STUDIES.find(study => study.key === key)
        || STUDIES.find(study => study.key === DEFAULT_STUDY_KEY);
}

export function getActiveStudyKey() {
    return localStorage.getItem(ACTIVE_STUDY_STORAGE_KEY) || DEFAULT_STUDY_KEY;
}

export function getActiveStudy() {
    return getStudy(getActiveStudyKey());
}

export function setActiveStudyKey(key) {
    localStorage.setItem(ACTIVE_STUDY_STORAGE_KEY, getStudy(key).key);
}
